import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, BarChart3Icon, ShieldIcon, CheckSquareIcon, FileTextIcon } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6" data-id="element-38" />,
    title: 'Ebook Estrategia NASDAQ PRO',
    desc: 'El manual paso a paso del Protocolo de Vela Única.'
  }, {
    icon: <BarChart3Icon className="w-6 h-6" data-id="element-39" />,
    title: 'Marco de Sesgo Institucional',
    desc: 'Cómo saber si el día es alcista o bajista en menos de 5 minutos.'
  }, {
    icon: <ShieldIcon className="w-6 h-6" data-id="element-40" />,
    title: 'Gestión de Riesgo Inquebrantable',
    desc: 'La matemática exacta del 0.5% para proteger tu Drawdown.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6" data-id="element-41" />,
    title: 'Checklist Pre-Mercado',
    desc: 'Los 5 pasos obligatorios antes de dar el primer clic a las 9:30 AM.'
  }, {
    icon: <FileTextIcon className="w-6 h-6" data-id="element-42" />,
    title: 'Guía de Reglas de Prop Firms',
    desc: "Cómo evitar las 'letras pequeñas' que descalifican a los traders novatos."
  }];
  return <section className="py-20 bg-trading-card/30 border-y border-white/5" data-id="element-43">
      <div className="container mx-auto px-4" data-id="element-44">
        <div className="max-w-5xl mx-auto" data-id="element-45">
          <div className="text-center mb-16" data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-heading text-white mb-4" data-id="element-47">
              Lo Que Obtienes Hoy
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-trading-gold to-trading-amber mx-auto rounded-full" data-id="element-48"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-49">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: idx % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className={`bg-trading-card border border-white/5 rounded-xl p-6 flex items-start gap-4 hover:bg-trading-cardHover transition-colors ${idx === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-50">
                <div className="p-3 bg-trading-gold/10 text-trading-gold rounded-lg flex-shrink-0" data-id="element-51">
                  {item.icon}
                </div>
                <div data-id="element-52">
                  <h3 className="text-lg font-heading text-white mb-2" data-id="element-53">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-54">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}